import { render, staticRenderFns } from "./MailerCampaigns.vue?vue&type=template&id=4274b127&scoped=true&"
import script from "./MailerCampaigns.vue?vue&type=script&lang=js&"
export * from "./MailerCampaigns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4274b127",
  null
  
)

export default component.exports